import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { PerformanceSliceState } from './performance.type';

const performanceInitialState: PerformanceSliceState = {
    tableFilterMap: {},
};

export const PERFORMANCE_REDUCER_NAME = 'performance';

export const performanceSlice = createSlice({
    name: PERFORMANCE_REDUCER_NAME,
    initialState: performanceInitialState,
    reducers: {
        setTableFilter: (
            state,
            action: PayloadAction<{
                filterId: keyof PerformanceSliceState['tableFilterMap'];
                value: string | null;
            }>,
        ) => {
            state.tableFilterMap[action.payload.filterId] =
                action.payload.value;
        },
        resetTableFilterMap: (state) => {
            state.tableFilterMap = {};
        },
    },
});

export const { setTableFilter, resetTableFilterMap } = performanceSlice.actions;

export const performanceReducer = performanceSlice.reducer;
